exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-resume-js": () => import("./../../../src/pages/resume.js" /* webpackChunkName: "component---src-pages-resume-js" */),
  "component---src-pages-work-godrej-js": () => import("./../../../src/pages/work/godrej.js" /* webpackChunkName: "component---src-pages-work-godrej-js" */),
  "component---src-pages-work-reckitt-js": () => import("./../../../src/pages/work/reckitt.js" /* webpackChunkName: "component---src-pages-work-reckitt-js" */)
}

